module.exports = __webpack_public_path__ + "static/img/2.0ed2800.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/eng/2.png
// module id = Fdl5
// module chunks = 0